import { Info } from 'lucide-react';
import { Button } from 'shared/ui/button';
import { TooltipWrapper } from 'shared/ui/tooltips/tooltip-wrapper';
import type { ReactNode } from 'react';
interface TooltipProps {
  text: string | ReactNode | undefined;
}
export const InfoTooltip = ({
  text
}: TooltipProps) => {
  if (!text) return;
  return <TooltipWrapper content={text} data-sentry-element="TooltipWrapper" data-sentry-component="InfoTooltip" data-sentry-source-file="info-tooltip.tsx">
      <Button type="button" variant="ghost" className="size-5 p-0" data-sentry-element="Button" data-sentry-source-file="info-tooltip.tsx">
        <Info size={16} data-sentry-element="Info" data-sentry-source-file="info-tooltip.tsx" />
      </Button>
    </TooltipWrapper>;
};